'use strict';
const { gql } = require('graphql-tag');

const log = true;

var _parent = {};

var batchjobs = {
  init: p => (_parent = p),

  /** Update the status of a batch job.
   *
   * @param {bigint} batchJobId - The ID of a batch job.
   * @param {string} status - The status string to update the batch job with.
   * @return {object} The response object confirming the update.
   */
  updateBatchJobStatus: async (batchJobId, status) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateBatchJobStatus($batchJobId: bigint!, $status: String!) {
          update_batch_jobs(where: { id: { _eq: $batchJobId } }, _set: { status: $status, updatedat: "now()" }) {
            affected_rows
            returning {
              id
              status
            }
          }
        }
      `,
      { batchJobId, status }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the status and output of a batch job.
   *
   * @param {bigint} batchJobId - The ID of a batch job.
   * @param {string} status - The status string to update the batch job with.
   * @param {object} output - The output object to update the batch job with.
   * @return {object} The response object confirming the update.
   */
  updateBatchJobStatusAndOutput: async (batchJobId, status, output) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateBatchJobStatusAndOutput($batchJobId: bigint!, $status: String!, $output: jsonb!) {
          update_batch_jobs(
            where: { id: { _eq: $batchJobId } }
            _set: { status: $status, output: $output, updatedat: "now()" }
          ) {
            affected_rows
            returning {
              id
              status
              output
            }
          }
        }
      `,
      { batchJobId, status, output }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },

  /** Update the status and append to the output of a batch job.
   *
   * @param {bigint} batchJobId - The ID of a batch job.
   * @param {string} status - The status string to update the batch job with.
   * @param {object} output - The output object to append to the batch job with.
   * @return {object} The response object confirming the update.
   */
  updateBatchJobStatusAndAppendOutput: async (batchJobId, status, output) => {
    const res = await _parent.gql.mutation(
      gql`
        mutation sdk_updateBatchJobStatusAndAppendOutput($batchJobId: bigint!, $status: String!, $output: jsonb!) {
          update_batch_jobs(
            where: { id: { _eq: $batchJobId } }
            _set: { status: $status, updatedat: "now()" }
            _append: { output: $output }
          ) {
            affected_rows
            returning {
              id
              status
              output
            }
          }
        }
      `,
      { batchJobId, status, output }
    );
    return _parent.gql.injectAffectedRowsAtRoot(res);
  },
};

module.exports = batchjobs;
